import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../components/shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AccountTypeGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {

    const accountType = this.authService.getAccountType();

    if (accountType === 'calculator') {
      // Calculator accounts can only access /calc, /business-details, /config
      const allowed = ['/calc', '/business-details', '/config'];
      if (!allowed.some(p => state.url.startsWith(p))) {
        this.router.navigate(['/calc']);
        return false;
      }
    }

    return true;
  }
}
